import { render } from "./NutritionLabel.vue?vue&type=template&id=642cd36c&scoped=true&ts=true"
import script from "./NutritionLabel.vue?vue&type=script&lang=ts"
export * from "./NutritionLabel.vue?vue&type=script&lang=ts"

import "./NutritionLabel.vue?vue&type=style&index=0&id=642cd36c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642cd36c"]])

export default __exports__